import * as shippingConstants from '../Constants/shippingConstants';
// import * as cartConstants from '../Constants/cartConstants';

export const shippingReducer = (state = {  shippingAddress: {}, shippingAreas: {} }, action) => {
  switch (action.type) {
    case shippingConstants.ADD_TO_SHIPPING_ITEM:
      const area = action.payload;
      

      const existArea = state.shippingAreas.find((x) => x.shippingd === area.shippingId);
     
      

      if (existArea) {
        return {
          ...state,
          shippingAreas: state.shippingAreas.map((x) => (x.shippingId === existArea.shippingId ? area : x)),
        };
      } else {
        return {
          ...state,
          shippingAreas: [...state.shippingAreas, area],
        };
      }
  
    case shippingConstants.SHIPPING_SAVE_SHIPPING_ADDRESS:
      return {
        ...state,
        shippingAddress: action.payload,
      };
    /* case cartConstants.CART_SAVE_PAYMENT_METHOD:
      return {
        ...state,
        paymentMethod: action.payload,
      }; */
    case shippingConstants.SHIPPING_RESET:
      return {
        area: [],
        shippingAddress: {},
        shippingAreas: {},
        // paymentMethod: '',
      };
    default:
      return state;
  }
};


export const listShippings = (state = { shippings: [] }, action) => {
  switch (action.type) {
    case shippingConstants.SHIPPINGLIST_FETCH_START:
      return {
        loading: true,
        shippings: [],
      };
    case shippingConstants.SHIPPINGLIST_FETCH_SUCCESS:
      return {
        shippings: action.payload.results,
        count: action.payload.count,
        success: true,
      };
    case shippingConstants.SHIPPINGLIST_FETCH_ERROR:
      return {
        error: action.payload,
      };

    default:
      return state;
  }
};

export const shipping = (state = { shipping: {} }, action) => {
  switch (action.type) {
    case shippingConstants.SHIPPING_FETCH_START:
      return {
        loading: true,
        shipping: {},
      };
    case shippingConstants.SHIPPING_FETCH_SUCCESS:
      return {
        shipping: action.payload,
        success: true,
      };
    case shippingConstants.SHIPPING_FETCH_FAIL:
      return {
        error: action.payload,
      };

    default:
      return state;
  }
};

export const deleteShipping = (state = {}, action) => {
  switch (action.type) {
    case shippingConstants.DELETE_SHIPPING_START:
      return {
        loading: true,
      };
    case shippingConstants.DELETE_SHIPPING_SUCCESS:
      return {
        success: true,
      };
    case shippingConstants.DELETE_SHIPPING_FAIL:
      return {
        error: action.payload,
      };

    case shippingConstants.DELETE_SHIPPING_RESET:
      return {};

    default:
      return state;
  }
};

export const createShipping = (state = {}, action) => {
  switch (action.type) {
    case shippingConstants.CREATE_SHIPPING_START:
      return {
        loading: true,
      };
    case shippingConstants.CREATE_SHIPPING_SUCCESS:
      return {
        success: true,
      };
    case shippingConstants.CREATE_SHIPPING_FAIL:
      return {
        error: action.payload,
      };

    case shippingConstants.CREATE_SHIPPING_RESET:
      return {};

    default:
      return state;
  }
};

export const EditShipping = (state = {}, action) => {
  switch (action.type) {
    case shippingConstants.EDIT_SHIPPING_START:
      return {
        loading: true,
      };
    case shippingConstants.EDIT_SHIPPING_SUCCESS:
      return {
        success: true,
      };
    case shippingConstants.EDIT_SHIPPING_FAIL:
      return {
        error: action.payload,
      };
    case shippingConstants.EDIT_SHIPPING_RESET:
      return {};
    default:
      return state;
  }
};
